import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../components/Header';
import Footer from '../../components/Footer';

export default function CompanyPage() {
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="pt-32 pb-16 bg-gradient-to-br from-teal-600 to-teal-700">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h2 className="text-4xl md:text-5xl font-bold text-white mb-4">
            会社概要
          </h2>
          <p className="text-lg text-teal-50">
            株式会社ArrayVentureについて
          </p>
        </div>
      </section>

      {/* Company Info Section */}
      <section id="about" className="py-20 bg-gray-50">
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="bg-white border border-gray-200 rounded-2xl overflow-hidden shadow-sm">
            <div className="divide-y divide-gray-200">
              <div className="grid md:grid-cols-4 gap-4 p-6">
                <div className="font-semibold text-gray-700">社名</div>
                <div className="md:col-span-3 text-gray-900">株式会社ArrayVenture</div>
              </div>
              <div className="grid md:grid-cols-4 gap-4 p-6">
                <div className="font-semibold text-gray-700">代表取締役</div>
                <div className="md:col-span-3 text-gray-900">今泉 隼人</div>
              </div>
              <div className="grid md:grid-cols-4 gap-4 p-6">
                <div className="font-semibold text-gray-700">設立年月日</div>
                <div className="md:col-span-3 text-gray-900">2025年1月23日</div>
              </div>
              <div className="grid md:grid-cols-4 gap-4 p-6">
                <div className="font-semibold text-gray-700">本店所在地</div>
                <div className="md:col-span-3 text-gray-900">
                  〒103-0012<br />
                  東京都中央区日本橋堀留町1-3-16 JSBレジデンス&オフィス日本橋 913号
                </div>
              </div>
              <div className="grid md:grid-cols-4 gap-4 p-6">
                <div className="font-semibold text-gray-700">事業内容</div>
                <div className="md:col-span-3 text-gray-900">ITシステム開発・コンサルティング</div>
              </div>
              <div className="grid md:grid-cols-4 gap-4 p-6">
                <div className="font-semibold text-gray-700">連絡先</div>
                <div className="md:col-span-3 text-gray-900">
                  <a href="mailto:info@array-venture.com" className="text-teal-600 hover:text-teal-700 cursor-pointer">
                    info@array-venture.com
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-white">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h3 className="text-2xl font-bold text-gray-900 mb-4">
            お気軽にお問い合わせください
          </h3>
          <p className="text-gray-600 mb-8">
            システム開発のご相談・お見積もりは無料で承っております。
          </p>
          <Link
            to="/contact"
            className="inline-block bg-teal-500 text-white px-10 py-4 rounded-lg text-base font-semibold hover:bg-teal-600 transition-all transform hover:scale-105 shadow-lg cursor-pointer"
          >
            お問い合わせはこちら
          </Link>
        </div>
      </section>

      <Footer />

      {/* Scroll to Top Button */}
      <button onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })} className={`fixed bottom-8 right-8 w-12 h-12 bg-teal-500 text-white rounded-full shadow-lg hover:bg-teal-600 transition-all flex items-center justify-center cursor-pointer ${isScrolled ? 'opacity-100' : 'opacity-0 pointer-events-none'}`} aria-label="ページトップへ">
        <i className="ri-arrow-up-line text-xl"></i>
      </button>
    </div>
  );
}
